import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboards-cards"
}
const _hoisted_2 = { class: "dashboards-cards__modal-body" }
const _hoisted_3 = {
  key: 0,
  class: "dashboards-cards__modal-list"
}
const _hoisted_4 = { class: "dashboards-cards__modal-name" }
const _hoisted_5 = { class: "dashboards-cards__modal-amount" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "dashboards-cards__modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "dashboards-cards__modal-list"
}
const _hoisted_9 = { class: "dashboards-cards__modal-name" }
const _hoisted_10 = { class: "dashboards-cards__modal-amount" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsIndicatorCards = _resolveComponent("DashboardsIndicatorCards")!
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_ctx.wrapInSection)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_DashboardsIndicatorCards, {
          config: _ctx.config,
          filter: _ctx.filter,
          onCardClick: _ctx.openModalWindow,
          clickableIndexes: [0, 1],
          getLinkParams: _ctx.getLinkParams,
          indicatorsColor: "blue",
          hideEmptyCards: ""
        }, null, 8, ["config", "filter", "onCardClick", "getLinkParams"]),
        _createVNode(_component_ModalComponent, {
          title: _ctx.getModalTitle,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowModal = false)),
          modelValue: _ctx.isShowModal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowModal) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DateActualDataSubtitle, {
                class: "dashboards-cards__modal-subtitle",
                filter: _ctx.filter,
                isSimpleYearLabel: ""
              }, null, 8, ["filter"]),
              (!_ctx.isLoadingModal)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRegionStatisticListEvents, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "dashboards-cards__modal-item"
                      }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.amount), 1),
                        _createElementVNode("span", {
                          class: "dashboards-cards__modal-arrow",
                          onClick: ($event: any) => (_ctx.redirectToDetailsPageByType(item.id))
                        }, null, 8, _hoisted_6)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_Loader, {
                    key: 1,
                    isCenterWidth: "",
                    class: "dashboards-cards__modal-loader"
                  })),
              _createVNode(_component_ButtonComponent, {
                mod: "gradient-bg",
                onClick: _ctx.redirectToDetailsPage
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Подробнее ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["title", "modelValue"])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_DashboardsIndicatorCards, {
          config: _ctx.config,
          filter: _ctx.filter,
          onCardClick: _ctx.openModalWindow,
          clickableIndexes: [0, 1],
          getLinkParams: _ctx.getLinkParams,
          isCardsWithGrid: false,
          indicatorsColor: "blue",
          hideEmptyCards: "",
          class: "dashboards-cards"
        }, null, 8, ["config", "filter", "onCardClick", "getLinkParams"]),
        _createVNode(_component_ModalComponent, {
          title: _ctx.getModalTitle,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModal = false)),
          modelValue: _ctx.isShowModal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowModal) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_DateActualDataSubtitle, {
                class: "dashboards-cards__modal-subtitle",
                filter: _ctx.filter,
                isSimpleYearLabel: ""
              }, null, 8, ["filter"]),
              (!_ctx.isLoadingModal)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRegionStatisticListEvents, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "dashboards-cards__modal-item"
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(item.amount), 1),
                        _createElementVNode("span", {
                          class: "dashboards-cards__modal-arrow",
                          onClick: ($event: any) => (_ctx.redirectToDetailsPageByType(item.id))
                        }, null, 8, _hoisted_11)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_Loader, {
                    key: 1,
                    isCenterWidth: "",
                    class: "dashboards-cards__modal-loader"
                  })),
              _createVNode(_component_ButtonComponent, {
                mod: "gradient-bg",
                onClick: _ctx.redirectToDetailsPage
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Подробнее ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["title", "modelValue"])
      ], 64))
}